import { Box, Link } from '@mui/material';

const SkipLink = () => {
  return (
    <Box
      component="div"
      sx={{
        position: 'fixed',
        top: -9999,
        left: 50,
        zIndex: 9999,
        '& a': {
          padding: '1rem',
          position: 'absolute',
          top: '50px',
          left: '50%',
          transform: 'translateX(-50%)',
          bgcolor: 'background.paper',
          color: 'text.primary',
          textDecoration: 'none',
          fontWeight: 'bold',
          borderRadius: '4px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
          '&:focus': {
            top: '50px',
            left: '50%',
            transform: 'translateX(-50%)',
            outline: '2px solid',
            outlineOffset: '2px',
          }
        }
      }}
    >
      <Link
        href="#main-content"
        sx={{
          clip: 'rect(0 0 0 0)',
          clipPath: 'inset(50%)',
          height: '1px',
          overflow: 'hidden',
          position: 'absolute',
          whiteSpace: 'nowrap',
          width: '1px',
          '&:focus': {
            clip: 'auto',
            clipPath: 'none',
            height: 'auto',
            width: 'auto',
            overflow: 'visible',
          }
        }}
      >
        Skip to main content
      </Link>
    </Box>
  );
};

export default SkipLink; 